import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import GenericCollapsibleDropdown from "../common/GenericCollapsibleDropDown";
// import cacPalette from './enhancedFeatures/cacPalette';
import { useDispatch } from '../common/react-redux-hooks';
import { CAC_LEFT_PANEL_BUILD_LABEL } from './CacConstants';
import { handleViewSwitch } from '../../actions/cacActions';


function CacGridData(props) {
  const {
    study,
    columns,
    rows,
    base,
    isBaseOpen,
    isRowsOpen,
    isColumnsOpen,
    isPassivesOpen,
    projectId,
    nodeColors,
  } = props.project;
  const passives = _.filter(
    _.concat(rows, columns),
    item => item.isPassive === true
  );
  const { toggleCollapsibleDropdown, addToPassive, showHideDataPoint } = props;
  // const { userId, currentAccountId } = useSelector(
  //   state => state.login.loginResponse.data
  // );
  const dispatch = useDispatch();

  // const getNodeRGB = nodeColor => {
  //   const palettes = cacPalette();
  //   const palette = _.find(palettes, { name: nodeColor });
  //   return palette
  //     ? palette.light
  //     : undefined;
  // };

  const handleViewChange = () => {
    dispatch(handleViewSwitch(CAC_LEFT_PANEL_BUILD_LABEL, projectId));
  };

  return (
    <div className="cac-grid-data" data-test="CacGridDataComponent">
      <div className="header-grid">
        <div className="header-grid-data" style={{ alignSelf: 'flex-start' }}>
          Data
        </div>
        <button
          type="button"
          className="cac_edit_button"
          onClick={() => handleViewChange()}
        >
          Edit
        </button>
      </div>
      <div className="study-label" title={study.sd}>
        STUDY: {study.sd}
      </div>
      <GenericCollapsibleDropdown
        data-test="BaseGenericCollapsibleDropdown"
        title="BASES"
        activeProjetId={projectId}
        data={base}
        count={base.length}
        isOpen={isBaseOpen}
        showPassiveIcon={false}
        keyType="isBaseOpen"
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        nodeColors={null}
        projectId={projectId}
      />
      <GenericCollapsibleDropdown
        title="COLUMNS"
        activeProjetId={projectId}
        data={columns}
        count={columns.length}
        isOpen={isColumnsOpen}
        showPassiveIcon
        keyType="isColumnsOpen"
        gridType="col"
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        addToPassive={addToPassive}
        showHideData={showHideDataPoint}
        allowColorChange
        nodeColors={nodeColors}
        projectId={projectId}
      />
      <GenericCollapsibleDropdown
        data-test="RowsGenericCollapsibleDropdown"
        title="ROWS"
        activeProjetId={projectId}
        data={rows}
        count={rows.length}
        isOpen={isRowsOpen}
        showPassiveIcon
        keyType="isRowsOpen"
        gridType="row"
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        addToPassive={addToPassive}
        showHideData={showHideDataPoint}
        allowColorChange
        nodeColors={nodeColors}
        projectId={projectId}
      />
      <GenericCollapsibleDropdown
        title="PASSIVES"
        activeProjetId={projectId}
        data={passives}
        count={passives.length}
        isOpen={isPassivesOpen}
        showPassiveIcon={false}
        keyType="isPassivesOpen"
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        allowColorChange={false}
        nodeColors={nodeColors}
        projectId={projectId}
      />
    </div>
  );
}

CacGridData.propTypes = {
  addToPassive: PropTypes.func,
  project: PropTypes.shape({
    study: PropTypes.instanceOf(Object),
    columns: PropTypes.arrayOf(PropTypes.shape({})),
    rows: PropTypes.arrayOf(PropTypes.shape({})),
    base: PropTypes.arrayOf(PropTypes.shape({})),
    isBaseOpen: PropTypes.bool,
    isRowsOpen: PropTypes.bool,
    isColumnsOpen: PropTypes.bool,
    isPassivesOpen: PropTypes.bool,
    projectId: PropTypes.number,
    nodeColors: PropTypes.shape({
      row: PropTypes.string,
      col: PropTypes.string,
      passive: PropTypes.string,
    }),
  }),
  showHideDataPoint: PropTypes.func,
  toggleCollapsibleDropdown: PropTypes.func,
};

export default CacGridData;
